import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import SeasonSnapshot from './season-snapshot-model'
import {
  CreateSeasonSnapshotAsync,
  DeleteSeasonSnapshotAsync,
  LoadSeasonSnapshotsAsync,
} from './seasonSnapshot-thunk'
const initialState: seasonSnapshotSliceState = {
  seasonSnapshot: [],
  selected_seasonSnapshot: '',
  is_loading_seasonSnapshot: false,
  is_creating_seasonSnapshot: false,
  is_deleting_seasonSnapshot: false,
}
export interface seasonSnapshotSliceState {
  seasonSnapshot: SeasonSnapshot[]
  selected_seasonSnapshot?: string
  is_loading_seasonSnapshot: boolean
  is_creating_seasonSnapshot: boolean
  is_deleting_seasonSnapshot: boolean
}
export const seasonSnapshotSlice = createSlice({
  name: 'seasonSnapshot',
  initialState,
  reducers: {
    setSelectedseasonSnapshot: (state, action) => {
      state.selected_seasonSnapshot = action.payload
    },
    clearStateseasonSnapshot: (state) => {
      state.seasonSnapshot = []
      state.is_loading_seasonSnapshot = false
      state.is_creating_seasonSnapshot = false
      state.is_deleting_seasonSnapshot = false
    },
    mergeseasonSnapshot: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_seasonSnapshot = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.seasonSnapshot = merge(state.seasonSnapshot, payload) as any
        }
      }
    },

    add_seasonSnapshot: (state, action) => {
      if (action.payload) {
        state.seasonSnapshot = [...state.seasonSnapshot, action.payload]
      }
    },
    set_seasonSnapshot: (state, action) => {
      let { key, value, id } = action.payload
      state.seasonSnapshot = state.seasonSnapshot.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSeasonSnapshotsAsync.pending, (state) => {
      state.is_loading_seasonSnapshot = true
    })
    builder.addCase(LoadSeasonSnapshotsAsync.fulfilled, (state, action) => {
      state.is_loading_seasonSnapshot = false
      if (action.payload) {
        state.seasonSnapshot = action.payload
      }
    })
    builder.addCase(LoadSeasonSnapshotsAsync.rejected, (state) => {
      state.is_loading_seasonSnapshot = false
    })
    builder.addCase(CreateSeasonSnapshotAsync.pending, (state) => {
      state.is_creating_seasonSnapshot = true
    })
    builder.addCase(CreateSeasonSnapshotAsync.fulfilled, (state) => {
      state.is_creating_seasonSnapshot = false
    })
    builder.addCase(CreateSeasonSnapshotAsync.rejected, (state) => {
      state.is_creating_seasonSnapshot = false
    })
    builder.addCase(DeleteSeasonSnapshotAsync.pending, (state) => {
      state.is_deleting_seasonSnapshot = true
    })
    builder.addCase(DeleteSeasonSnapshotAsync.fulfilled, (state, action) => {
      state.is_deleting_seasonSnapshot = false
      if (state.seasonSnapshot) {
        state.seasonSnapshot = state.seasonSnapshot.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSeasonSnapshotAsync.rejected, (state) => {
      state.is_deleting_seasonSnapshot = false
    })
  },
})

export const {
  clearStateseasonSnapshot,
  setSelectedseasonSnapshot,
  set_seasonSnapshot,
  mergeseasonSnapshot,
  add_seasonSnapshot,
} = seasonSnapshotSlice.actions

export const get_seasonSnapshot =
  (id?: string) =>
  (state: {
    seasonSnapshot: {
      seasonSnapshot: SeasonSnapshot[]
    }
  }): SeasonSnapshot | null => {
    let temp = state?.seasonSnapshot?.seasonSnapshot?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.seasonSnapshot?.seasonSnapshot[0] || null
  }
export const get_selected_seasonSnapshot = (state: {
  seasonSnapshot: seasonSnapshotSliceState
}): SeasonSnapshot | null => {
  let id = state?.seasonSnapshot?.selected_seasonSnapshot
  let temp = state?.seasonSnapshot?.seasonSnapshot?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_seasonSnapshot = (state: {
  seasonSnapshot: {
    seasonSnapshot: SeasonSnapshot[]
  }
}): SeasonSnapshot[] => {
  let temp = state?.seasonSnapshot?.seasonSnapshot
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_seasonSnapshot_busy = (state: {
  seasonSnapshot: seasonSnapshotSliceState
}) => {
  return (
    state?.seasonSnapshot.is_deleting_seasonSnapshot ||
    state?.seasonSnapshot.is_loading_seasonSnapshot ||
    state?.seasonSnapshot.is_creating_seasonSnapshot
  )
}
export const is_deleting_seasonSnapshot_busy = (state: {
  seasonSnapshot: seasonSnapshotSliceState
}) => {
  return state?.seasonSnapshot.is_deleting_seasonSnapshot
}
export const is_loading_seasonSnapshot_busy = (state: {
  seasonSnapshot: seasonSnapshotSliceState
}) => {
  return state?.seasonSnapshot.is_loading_seasonSnapshot
}
export const is_creating_seasonSnapshot_busy = (state: {
  seasonSnapshot: seasonSnapshotSliceState
}) => {
  return state?.seasonSnapshot.is_creating_seasonSnapshot
}

export default seasonSnapshotSlice.reducer
